export const APP_VERSION = '3.4.242';
export const BUILD_DATE = '20230927-1130';

